var am = angular.module('ep-onstar-dealer-incentive', ['ui.router']);

am.config(['$stateProvider', (function ($stateProvider) {
    $stateProvider.state('onstar-dealer-incentive', {
        url: '/onstar-dealer-incentive/:view',
        templateUrl: 'feature/program/onstar-dealer-incentive/onstar-dealer-incentive.html',
        controller: 'onstarDealerIncentiveCtrl'
    });
})]);

am.factory('embeddedOdiReportSvc', [
    '$http', 'rest',
    ($http, rest) => {
        const svc = {};

        // get Embedded ODI Report
        svc.getEmbeddedOdiReport = (reportName, language, bac) => {
            const url = rest.getRestUrlPrefix() + `reports/getODIEmbeddedReport/${reportName}${language}/${bac}`;
            return $http.get(url);
        };

        return svc;
    }
]);

am.controller('odiReportTileCtrl', [
    '$scope', '$rootScope', '$state', 'loginSvc',
    ($scope, $rootScope, $state, loginSvc) => {
        $scope.tileHeaderText = '';
        $scope.languagePreference = sessionStorage.languagePreference;
        // get assets from CDN
        loginSvc.getJSONFileData().then(({ data }) => {
            $scope.onstarLogoTileUrl = data.odiTileImages.onstarLogo;
            if (sessionStorage.languagePreference.toLowerCase() === 'en') {
                // Dealer Incentive tile image English
                $scope.logoAsset = data.odiTileImages.enUrl;
                $scope.tileHeaderText = 'OnStar Dealer Incentive Reporting';
            }

            else if (sessionStorage.languagePreference.toLowerCase() === 'fr') {
                // Dealer Incentive tile image French
                $scope.logoAsset = data.odiTileImages.frUrl;
                $scope.tileHeaderText = 'Rapports sur les incitations des concessionnaires OnStar';
            }

            else {
                // Dealer Incentive tile image English by default
                $scope.logoAsset = data.odiTileImages.enUrl;
                $scope.tabHeadingDealerExcellence = 'DEALER EXCELLENCE';
            }
        }).catch((err) => {
            console.log('Oops, error getting getJSONFileData', err);
        });

        $scope.goOdiReport = (function (view) {
            $scope.program = $rootScope.program;
            if (!$rootScope.program) {
                $scope.program = [];
                $scope.program.name = "OnStar Dealer Incentive";
                $scope.program.securityTarget = [];
                $scope.program.securityTarget.securityTargetType = "Program";
                // $scope.program.securityTarget.id = 2704;
                $scope.program.code = "";
                $scope.program.roles = [];
                $scope.program.roles[0] = "VIEWER";
                $scope.program.roles[1] = "OWNER";
                $scope.program.roles[2] = "GIVER";
                $scope.program.administrator = false;
                $scope.program.view = 'program';
                $rootScope.program = $scope.program;
            }
            $rootScope.program = $scope.program;
            if (view) {
                $scope.program.view = view;
            } else {
                $scope.program.view = 'program';
            }
            var action = '';
            if ($scope.program.view === 'program') {
                action = 'Reports Button Clicked';
            } else if ($scope.program.view === 'tools') {
                action = 'Tools Button Clicked';
            }
            // var eventAction = $scope.program.name + ' ' + action;
            // var eventParameters = {
            //     'event_category': 'Tile Click',
            //     'event_label': 'Tile Clicked'
            // };
            // googleAnalyticsSvc.callGoogleAnalytics('event', '', '', eventAction, eventParameters);
            $state.go('onstar-dealer-incentive', { 'view': $scope.program.view });
        });
    }
]);

am.controller('onstarDealerIncentiveCtrl', ['$scope', '$rootScope', '$sce', 'embeddedOdiReportSvc', 'googleAnalyticsSvc', '$state', '$window', 'dialogSvc', 'L10nFilter', 'loginSvc', ($scope, $rootScope, $sce, embeddedOdiReportSvc, googleAnalyticsSvc, $state, $window, dialogSvc, l10nFilter, loginSvc) => {
    angular.element(document).ready(function () {
        $scope.urlWithoutHost = window.location.href.toString().split(window.location.host)[1];
        $scope.getLastWord = $scope.urlWithoutHost.split('/')[$scope.urlWithoutHost.split('/').length - 1];
        $scope.viewFromURL = $scope.getLastWord;
        var browser = navigator.userAgent.toLowerCase();
        if ((browser.indexOf('edge') > 0 || browser.indexOf('msie') > 0 || browser.indexOf('.net') > 0 || browser.indexOf('firefox') > 0) && (sessionStorage.browserChecked === undefined)) {
            sessionStorage.browserChecked = true;
            dialogSvc.showMessage(l10nFilter('update-browser', null, true), l10nFilter('not-chrome-browser', null, true));
        } else {
            sessionStorage.browserChecked = true;
        }
        if (!$rootScope.program) {
            $scope.program = [];
            $scope.program.name = "OnStar Dealer Incentive";
            $scope.program.securityTarget = [];
            $scope.program.securityTarget.securityTargetType = "Program";
            //$scope.program.securityTarget.id = 2704;
            $scope.program.code = "";
            $scope.program.roles = [];
            $scope.program.roles[0] = "VIEWER";
            $scope.program.roles[1] = "OWNER";
            $scope.program.roles[2] = "GIVER";
            $scope.program.administrator = false;
            $scope.program.view = 'program';
            $rootScope.program = $scope.program;
        } else {
            $scope.program = $rootScope.program;
        }
        $scope.languagePreference = sessionStorage.languagePreference;

        loginSvc.getJSONFileData().then(({ data }) => {

            //$scope.onstarLogoTileUrl = data.odiTileImages.onstarLogo;
            $scope.onstarLogoPageUrl = data.odiReport.onstarLogoPageUrl;
            $scope.odiBackground = data.odiReport.bgImgPageUrl;

            if (sessionStorage.languagePreference.toLowerCase() === 'en') {
                // Dealer Incentive English Assets
                $scope.logoAsset = data.odiTileImages.enUrl;
                $scope.onstarLogoPageUrl = data.odiReport.onstarLogoPageUrlEn;
                $scope.odiReportTitle = data.odiReport.odiReportTitleEn;
                $scope.tabHeadingOverview = data.odiReport.tabHeadingOverviewEn;
                $scope.tabHeadingEarnings = data.odiReport.tabHeadingEarningsEn;
                $scope.tabHeadingDealerExcellence = 'DEALER EXCELLENCE';
                $scope.programRulesODETitle = data.odiReport.programRulesODETitleEnV;
                //Program Rules 
                $scope.programRulesNTitle = data.odiReport.programRulesNTitleEn;
                $scope.programRulesPOTitle = data.odiReport.programRulesPTitleEn;
                $scope.programRulesNew = data.odiReport.onStarProgramRulesNewV;
                $scope.programRulesPO = data.odiReport.onStarProgramRulesPOV;
                $scope.programRulesODE = data.odiReport.programRulesODEEnV;
            }

            else if (sessionStorage.languagePreference.toLowerCase() === 'fr') {
                // Dealer Incentive French Assets
                $scope.logoAsset = data.odiTileImages.frUrl;
                $scope.onstarLogoPageUrl = data.odiReport.onstarLogoPageUrlFr;
                $scope.odiReportTitle = data.odiReport.odiReportTitleFr;
                $scope.tabHeadingOverview = data.odiReport.tabHeadingOverviewFr;
                $scope.tabHeadingEarnings = data.odiReport.tabHeadingEarningsFr;
                $scope.tabHeadingDealerExcellence = 'EXCELLENCE DES CONCESSIONNAIRES';
                $scope.programRulesODETitle = data.odiReport.programRulesODETitleFrV;
                //Program Rules 
                $scope.programRulesNTitle = data.odiReport.programRulesNTitleFr;
                $scope.programRulesPOTitle = data.odiReport.programRulesPTitleFr;
                $scope.programRulesNew = data.odiReport.onStarProgramRulesNewFR;
                $scope.programRulesPO = data.odiReport.onStarProgramRulesPoFR;
                $scope.programRulesODE = data.odiReport.programRulesODEFrV;
            }

            else {
                // Dealer Incentive images English by default
                $scope.logoAsset = data.odiTileImages.enUrl;
                $scope.onstarLogoPageUrl = data.odiReport.onstarLogoPageUrlEn;
                $scope.odiReportTitle = data.odiReport.odiReportTitleEn;
                $scope.tabHeadingOverview = data.odiReport.tabHeadingOverviewEn;
                $scope.tabHeadingEarnings = data.odiReport.tabHeadingEarningsEn;
            }

            $scope.getEmbeddedReport('overview');
            $scope.getEmbeddedReport('dealerExcellence');

        }).catch((err) => {
            console.log('Oops, error getting getJSONFileData', err);
        });
    });

    $scope.getEmbeddedReport = (reportName) => {

        $scope.tab = reportName;
        const bac = sessionStorage.bac;

        // getting credentials for ODI Report
        embeddedOdiReportSvc.getEmbeddedOdiReport(reportName, $scope.languagePreference.toUpperCase(), bac).then(response => {
            const embeddedURL = response.data.embeddedURL;
            const params = {
                "Token": response.data.token,
                "Token2": response.data.token,
                "Token3": response.data.token
            };
            const paramString = JSON.stringify(params);
            const encodeParamString = encodeURIComponent(paramString);
            $scope.iframeUrl = $sce.trustAsResourceUrl(embeddedURL + `?params=` + encodeParamString);

            if (!embeddedURL) {
                $scope.isThereAnError = true;
                dialogSvc.showMessage('An error has occurred getting the report - please try again...');
            }

            $scope.isLoading = false;


        }).catch((err) => {
            console.log('Error getting embedded report - please try again later...', err);
        });
    };
}]);